import { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./css/Login.css";
import api from "./api/api";
import Logo from './Images/logo.png';

function Login() {

  const navigate = useNavigate();

  const [loginname, setLoginname] = useState("");
  const [pwd, setPwd] = useState("");
  const [showPwd, setShowPwd] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleLogin = async () => {
    setError("");

    if (!loginname.trim()) return setError("Please enter your login name.");
    if (!pwd.trim()) return setError("Please enter your password.");

    setLoading(true);

    try {

      const res = await api.post("/Login/auth", {
        loginname: loginname,
        pwd: pwd
      });

      const user = res.data;

      localStorage.setItem("user", JSON.stringify(user));
     localStorage.setItem("isLogin", "true");

      navigate("/YashShop");

    } catch (err) {

      if (err.response) {
        setError(err.response.data || "Invalid credentials.");
      } else {
        setError("Unable to reach server.");
      }

    } finally {
      setLoading(false);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") handleLogin();
  };  
  
  return (
    <div className="login-wrapper">

      {/* LEFT PANEL */}
      <div className="login-left">
        <div className="login-left-bg" />
        {/* <div className="login-left-overlay" /> */}

        {/* <div className="login-left-content">
          <div className="login-left-brand">
            <span className="login-left-brand-dot" />
            YashShop
          </div>

          <div className="login-left-text">
            <h1>Run your shop,<br />the smarter way.</h1>
            <p>Track inventory, manage sales, and grow your business — all from one powerful dashboard built for modern retailers.</p>
          </div>
        </div> */}
      </div>

      {/* RIGHT PANEL */}
      <div className="login-right">
        <div className="login-card">

          <div className="login-card-header">
            <div className="login-card-avatar">
<img
  src={Logo}
  alt="YashShop Logo"
  className="login-logo"
/>            </div>
            <h2 className="login-card-title">Welcome</h2>
            <p className="login-card-sub">Sign in to your account to continue</p>
          </div>

          {error && (
            <div className="login-error">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="12" cy="12" r="10"/>
                <line x1="12" y1="8" x2="12" y2="12"/>
                <line x1="12" y1="16" x2="12.01" y2="16"/>
              </svg>
              {error}
            </div>
          )}

          <div className="login-field">
            <label>Login Name</label>
            <div className="login-input-wrap">
              <span className="login-input-icon">
                <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
                  <circle cx="12" cy="7" r="4"/>
                </svg>
              </span>
              <input
                type="text"
                className="login-input"
                placeholder="Enter your login name"
                value={loginname}
                onChange={(e) => setLoginname(e.target.value)}
                onKeyDown={handleKeyDown}
                autoFocus
                autoComplete="username"
              />
            </div>
          </div>

          <div className="login-field">
            <label>Password</label>
            <div className="login-input-wrap">
              <span className="login-input-icon">
                <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
                  <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
                </svg>
              </span>
              <input
                type={showPwd ? "text" : "password"}
                className="login-input"
                placeholder="Enter your password"
                value={pwd}
                onChange={(e) => setPwd(e.target.value)}
                onKeyDown={handleKeyDown}
                autoComplete="current-password"
              />
              <button
                type="button"
                className="login-eye-btn"
                onClick={() => setShowPwd(!showPwd)}
                tabIndex={-1}
                aria-label={showPwd ? "Hide password" : "Show password"}
              >
                {showPwd ? (
                  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94"/>
                    <path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19"/>
                    <line x1="1" y1="1" x2="23" y2="23"/>
                  </svg>
                ) : (
                  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
                    <circle cx="12" cy="12" r="3"/>
                  </svg>
                )}
              </button>
            </div>
          </div>

          <button
            className="login-submit-btn"
            onClick={handleLogin}
            disabled={loading}
          >
            {loading ? (
              <>
                <span className="login-spinner" />
                Signing in…
              </>
            ) : (
              <>
                Sign In
                <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                  <line x1="5" y1="12" x2="19" y2="12"/>
                  <polyline points="12 5 19 12 12 19"/>
                </svg>
              </>
            )}
          </button>

          <div className="login-divider">Secured Access</div>

        </div>
      </div>

    </div>
  );
}

export default Login;